import { fabric as g } from "fabric";
const b = async ({
  logoImgBlob: e,
  logoImgURL: o,
  targetWidth: r,
  targetHeight: n,
  padding: c,
  // TODO: _devicePixelRatio logic needs to be dynamically created
  devicePixelRatio: F
}) => {
  if (!e || !o)
    return;
  const s = e;
  if (!s)
    return;
  const m = r - c, h = n - c;
  return await new Promise((a) => {
    const l = URL.createObjectURL(s), t = new Image();
    t.onload = () => {
      const u = Math.min(m / t.width, h / t.height), i = new g.Image(t, {
        originX: "center",
        originY: "center"
      });
      i.applyResizeFilters(), i.scale(u), a(i);
    }, t.onerror = () => {
      a(void 0);
    }, t.src = l;
  });
}, x = ({
  targetWidth: e,
  targetHeight: o,
  outerBoxOption: r
}) => new g.Rect({
  width: e,
  height: o,
  fill: "#FFFFFF",
  rx: 4,
  ry: 4,
  strokeWidth: -1,
  stroke: "#E5E5E5",
  ...r
});
export {
  b as createLogoFabricImg,
  x as createLogoOuterBox
};
//# sourceMappingURL=index.es393.js.map
